import { useRef, useEffect } from 'react';
import './TimelineItem.scss';
import Pills from '../pills/Pills';

export default function TimelineItem({ timelineRef, experience: { title, start, end, description, skills } }) {
  const timelineItemRef = useRef();

  useEffect(() => {
    const handleScroll = (event) => {
      if (timelineItemRef.current.offsetTop + timelineRef.current.offsetTop <= window.scrollY + window.innerHeight / 2) {
        timelineItemRef.current.className = "timeline-item active";
      } else {
        timelineItemRef.current.className = "timeline-item";
      }

    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return (
    <>
      <div className="timeline-item" ref={timelineItemRef}>
        <div className="experience-card">
          <div className="experience-card-year">
            <h2>{start} - {end ? end : 'present'}</h2>
          </div>
          <div className="experience-card-description">
            <h3>{title}</h3>
            <p>{description}</p>
            <Pills pills={skills}></Pills>
          </div>
        </div>
      </div>
    </>
  );
}